import { createFileRoute } from '@tanstack/react-router';
import { ManageAgreementsPage } from '@/pages/member-portal/agreements/ManageAgreementsPage';
import { agreementGroupSearchSchema } from '@/pages/member-portal/agreements/agreementGroups';

function MemberPortalManageAgreementsRoute() {
	return <ManageAgreementsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/agreements')({
	component: MemberPortalManageAgreementsRoute,
	validateSearch: agreementGroupSearchSchema,
});
